import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'

export const MissionsListEmptyState = () => {
  return (
    <div className="m-auto mt-8 max-w-[350px] rounded-xl bg-[var(--color-gray-100)] p-6">
      <Text>
        <Trans>No missions available at the moment.</Trans>
      </Text>
    </div>
  )
}

export const MissionsFiltersEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12">
      <Text type="body1-regular" className="text-gray-80">
        <Trans>No missions match your filters.</Trans>
      </Text>
      <Text type="body3-regular" className="text-gray-80">
        <Trans>Try adjusting the search or clearing type filters.</Trans>
      </Text>
    </div>
  )
}

export const MissionsTabEmptyState = ({ label }: { label: string }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12">
      <Text type="body1-regular" className="text-gray-80">
        <Trans>No &quot;{label}&quot; missions yet.</Trans>
      </Text>
    </div>
  )
}
